/**
 * Created by Anam Farrukh
 */
(function () {
    angular.module('tmx-common')
        .factory('populateDate', function () {
            var startDate;
            var endDate;
            return {
                setStartDateObject: function(sdate){ //expected any input
                    startDate = new Date(sdate);

                    startDate.setHours(5,0,0);
                    return startDate;
                },
                setEndDateObject:function(edate){ //any input
                    if(edate == null || !angular.isDefined(edate)){
                        endDate = new Date(edate);//forming a date object from JSON string
                        return endDate;
                    }
                    if(angular.isObject(edate)){
                        endDate = edate.toJSON();
                    }
                    else{
                        endDate = edate;
                    }

                    endDate = endDate.split("T");
                    endDate = new Date(endDate[0]);
                    endDate.setHours(28,59,59);
                    return endDate;
                }
            };


        });

})();